import { Complaint } from '../Complaint'
import { formSchema } from './schema'
import { whistleblowerRetaliation } from '../../strings/titles'
import { dateToString } from '../../utilities/methods/dateToString'
import { formatYesNoToTrueFalse } from '../../utilities'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class WhistleblowerRetaliationComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'whistleblower_retaliation'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.whistleblower.confirmation
  }

  /*
   * Combine the whistleblower unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const {
      communication_contact,
      communication_contact_other,
      disclosure_date,
      disclosure_type,
      employer_other,
      employer_warning,
      non_anon_perm_to_disclose,
      perm_to_disclose,
      protected_communication_warning,
      protected_disclosure_warning,
      retaliation_action,
      retaliation_action_other,
      retaliation_reason,
      retaliation_reasons_warning,
      still_happening,
      subject_type_0
    } = formData

    let disclosure_permission = ''
    // Anonymous has a higher precidence, so check it first.
    if (perm_to_disclose) {
      disclosure_permission = perm_to_disclose
    } else if (non_anon_perm_to_disclose) {
      disclosure_permission = non_anon_perm_to_disclose
    }

    const detail = {
      disclosure_permission,
      disclosure_type,
      employer_other,
      employer_warning_ack: formatYesNoToTrueFalse(employer_warning),
      communication_contact,
      communication_contact_other,
      known_subject: subject_type_0 === 'unknown' ? 'False' : 'True',
      protected_communication_warning_ack: formatYesNoToTrueFalse(
        protected_communication_warning
      ),
      communication_contact_date: dateToString(disclosure_date),
      protected_disclosure_warning_ack: formatYesNoToTrueFalse(
        protected_disclosure_warning
      ),
      retaliation_action,
      retaliation_action_other,
      retaliation_reason,
      retaliation_reasons_warning_ack: formatYesNoToTrueFalse(
        retaliation_reasons_warning
      ),
      retaliation_still_happening: formatYesNoToTrueFalse(still_happening)
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}

export default withRecaptcha(
  withBackButtonProtection(
    withDocTitle(WhistleblowerRetaliationComplaint, whistleblowerRetaliation)
  )
)
